import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

export default css`
  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  @media (min-width: 48rem) {
    .Spread__item--0,
    .Spread__item--ad {
      flex: 0 0 100%;
    }

    .Spread__items {
      flex-wrap: wrap;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) and (max-width: 63.99rem) {
      .Spread__item--0 {
        padding: 0 1.5rem;
      }
    }

    @media (min-width: 64em) {
      .Spread--everyday {
        position: relative;
        display: flex;
        flex-direction: column;
      }

      .Spread__description,
      .Spread__title {
        align-self: stretch;
        margin: 0 1.5rem 1.5rem calc((100% - ${pageWidth.large}) / 2);
        max-width: ${pageWidth.large};
      }

      .Spread__item--0 {
        grid-column-start: 2;
        width: 100%;
      }

      .Spread__item--ad {
        grid-column: span 3;
      }

      .Spread__items {
        grid-template-columns:
          calc((100vw - ${pageWidth.large}) / 2)
          minmax(calc((${pageWidth.large} * 0.58) - 1.5rem), ${pageWidth.large})
          minmax(0, calc((100vw - ${pageWidth.large}) / 2));
        width: 100%;
        padding: 0;
      }
    }

    @media (min-width: 75rem) {
      .Spread__description,
      .Spread__title {
        margin: 0 1.5rem 1.5rem calc((100% - ${pageWidth.midlarge}) / 2);
        max-width: ${pageWidth.midlarge};
      }

      .Spread__items {
        grid-template-columns:
          calc((100vw - ${pageWidth.midlarge}) / 2)
          minmax(
            calc((${pageWidth.midlarge} * 0.58) - 1.5rem),
            ${pageWidth.midlarge}
          )
          minmax(0, calc((100vw - ${pageWidth.midlarge}) / 2));
      }
    }
  }
`;
